import { reportToGoogleAnalytics } from "../../../../google-analytics/state/googleAnalyticsMiddleware";

// This will make the validation errors appear in GA + Medallia
export const reportValidationErrorsToGa = (errors: string[]) => {
    const message =
        errors.length > 0 ? errors.join(" ") : "Ordrevalidering feilet. Kontroller ordredetaljene og prøv igjen.";
    // Mask any 8 digit or 10 digit phone numbers
    const maskedMessages = message.replace(/\b\d{8}\b/g, "********").replace(/\b\d{10}\b/g, "**********");
    reportToGoogleAnalytics("WEBSHOP_WARNING", maskedMessages);
};
